module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-menu",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-ctx"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("健康服务")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cszb()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-cslive"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("淳善直播")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("健康方面咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.xlzx()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-juzhuzhengxinxishenbao"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("心理咨询")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("心理方面咨询")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2968139d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/health_dialog/health_dialog.vue
// module id = 310
// module chunks = 40